import { translate } from "@escapio/shared/l10n/translate";
import { hasConsentChecked } from "@escapio/shared/tracker/ConsentObserver";
import { html, render } from "lit-html";

customElements.define(
	"esc-privacy-settings",
	class extends HTMLElement {
		connectedCallback() {
			render(html`<span>&nbsp;</span>`, this, { host: this });
			hasConsentChecked.then(({ triggerPrivacySettings }) => {
				render(
					html`<button @click=${triggerPrivacySettings}>
						${translate("main_menu_privacy_label")}
					</button>`,
					this,
					{ host: this },
				);
			});
		}
	},
);
